import {AfterViewInit, Component} from '@angular/core';
import {ReserveSelectDetailFormFragmentController} from './ReserveSelectDetailFormFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {MstClinicDTOInterface} from '../../../../../../../DTO/MstClinicDTOInterface';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';
import {DepartmentListDTOInterface} from '../../../../../../../DTO/DepartmentListDTOInterface';
import {ReserveAlertListDTOInterface} from '../../../../../../../DTO/ReserveAlertListDTOInterface';
import {MatRadioChange} from '@angular/material/radio';
import {ReserveDepartmentAlertPopoverComponent} from './ReserveDepartmentAlert/ReserveDepartmentAlertPopoverComponent';
import {
	ReserveDepartmentExamAlertPopoverComponent
} from './ReserveDepartmentExamAlert/ReserveDepartmentExamAlertPopoverComponent';
import {DepartmentExamDTOInterface} from '../../../../../../../DTO/DepartmentExamDTOInterface';
import {ReservePopoverAlertComponent} from '../../ReservePopoverAlert/ReservePopoverAlertComponent';
import {
	ReserveDepartmentSelectPopoverComponent
} from './ReserveDepartmentSelect/ReserveDepartmentSelectPopoverComponent';
import {
	ReserveDepartmentExamSelectPopoverComponent
} from './ReserveDepartmentExamSelect/ReserveDepartmentExamSelectPopoverComponent';

/**
 * ReserveSelectDetailFormFragmentComponent
 * 予約スタート画面
 */
@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveSelectDetailFormFragmentComponent.html',
	styleUrls: ['../ReserveCreateFormLayout.scss', './ReserveSelectDetailFormFragmentComponent.scss'],
})
export class ReserveSelectDetailFormFragmentComponent extends BaseViewUI {

	// 紐付いたコントローラー
	public combineCtrl: ReserveSelectDetailFormFragmentController;

	public eventSelectDate: () => void;
	public eventSetReserveSaveData: (reserve: ReservationSaveDTOInterface) => void;
	public eventChangeClinic: () => Promise<any>;

	public reserveModel: ReservationSaveDTOInterface = {
		id: 0,
		clinicId: 0,
		doctorId: 0,
		departmentId: 0,
		userId: 0,
		reservationDate: '',
		reservationFrom: '',
		reservationTo: '',
		exam: [],
		examList: [],
		memo: '',
		memoUser: '',
		cancelDate: '',
		visitType: '',
		appointmentType: ''
	};

	// クリニックリスト
	// 親から設定される
	public clinicList: Array<MstClinicDTOInterface> = [];

	public visitTypeList: Array<any> = [
		{id: 'FIRST', name: '初診'},
		{id: 'AGAIN', name: '再診'}
	];

	public appointmentTypeList = [
		{id: 'VISIT', name: '来院予約'},
		{id: 'ONLINE', name: 'オンライン診療予約'}
	];

	// 来院診療科
	public departmentVisitList: Array<DepartmentListDTOInterface> = [];

	// オンライン診療科
	public departmentOnlineList: Array<DepartmentListDTOInterface> = [];

	// 画面のselectで表示するリスト
	// departmentVisitListかdepartmentOnlineListが入る
	public departmentList: Array<DepartmentListDTOInterface>;
	public selectedDepartment: DepartmentListDTOInterface;
	// 診察内容
	// 単一選択用にselectedExamを設定、複数選択になった場合は不要
	public examList: any = [
		{id: 0, departmentId: 0, name: '発熱・かぜ・その他体調不良', description: '', timeAgain: 0, timeFirst: 0, isChecked: false},
	];
	public selectedExam: DepartmentExamDTOInterface;
	public selectedExamId = 0;//いらないはず

	// 来院、オンライン、初診、再診選択時の注意事項
	// 親から設定される
	public alertList: ReserveAlertListDTOInterface;
	// 項目選択時に表示するアラート
	public selectedAppointmentTypeCaution: Array<{title: string; content: string}> = [];
	public selectedVisitTypeCaution: Array<{title: string; content: string}> = [];

	public errorMessageList = {
		clinic: '',
		department: '',
		appointmentType: '',
		visitType: '',
	};

	// エレメントの表示・非表示
	// クエリに基づいて親から設定される
	public visible = {
		clinic: true,
		department: true,
		appointmentType: true,
		exam: true,
		visitType: true,
	};

	/**
	 * constructor
	 */
	public constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveSelectDetailFormFragmentController);

	}


	/**
	 * 開始処理
	 */
	public async start() {
		this.log('ReserveSelectDetailFormFragmentComponent::start()');
		this.log(this.reserveModel);
		this.sendFingerprintLog('ReserveSelectDetailFormFragmentComponent', 'show');
		// 診療科で症状
		await this.setDepartmentList(this.reserveModel.appointmentType);
		await this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);

		if (this.reserveModel.departmentId !== 0) {
			this.departmentList.forEach((value) => {
				if (this.reserveModel.departmentId === value.id) {
					this.selectedDepartment = value;
				}
			});

			if (this.reserveModel.exam.length > 0) {
				for (const exam of this.examList) {
					if (exam.isChecked === true) {
						this.selectedExam = exam;
					}
				}
			}

			if (this.reserveModel.examList.length > 0) {
				for (const exam of this.examList) {
					this.selectedExam = exam;
				}
			}
		}
	}

	/**
	 * 診察内容のリストをセットする
	 * @param departmentId
	 * @param appointmentType
	 * @private
	 */
	private async setExamList(departmentId: number, appointmentType: string): Promise<void> {
		let examList = [];
		for (const department of this.departmentList) {
			if (department.id === departmentId) {
				switch (appointmentType) {
					case 'VISIT':
						examList = department.mstExamination.visit;
						break;

					case 'ONLINE':
						examList = department.mstExamination.online;
						break;
				}
			}
		}

		// 診察内容
		this.examList = [];
		for (const exam of examList) {
			if (this.reserveModel.exam.includes(exam.id)) {
				exam.isChecked = true;
				// 単一選択時の設定
				// 複数選択になった場合は削除する
				this.selectedExam = exam;
			} else {
				exam.isChecked = false;
			}
			this.examList.push(exam);
		}

	}

	/**
	 * 診療科のデータ設定
	 * 来院、オンラインにより選択肢が異なる
	 * @param appointmentType
	 * @private
	 */
	private async setDepartmentList(appointmentType: string): Promise<void> {
		let departmentList = [];
		switch (appointmentType) {
			case 'VISIT':
				departmentList = this.departmentVisitList;
				break;

			case 'ONLINE':
				departmentList = this.departmentOnlineList;
				break;
		}

		this.departmentList = departmentList;
	}

	/**
	 * 日時選択画面へ遷移
	 */
	public async selectDate(): Promise<void> {
		let isShowDialog = true;
		const errorMessages = {
			clinic: '',
			department: '',
			exam: '',
			appointmentType: '',
			visitType: '',
		};
		if (this.reserveModel.clinicId === 0) {
			isShowDialog = false;
			errorMessages.clinic = '※クリニックが選択されていません。';
		}
		if (this.reserveModel.departmentId === 0) {
			isShowDialog = false;
			errorMessages.department = '※診療科が選択されていません。';
		}
		if (this.reserveModel.appointmentType === 'NONE') {
			isShowDialog = false;
			errorMessages.appointmentType = '※来院・オンライン診療が選択されていません';
		}
		if (this.reserveModel.visitType === 'NONE') {
			isShowDialog = false;
			errorMessages.visitType = '※初診・再診が選択されていません';
		}
		const examList = [];
		for (const exam of this.examList) {
			if (exam.isChecked === true) {
				examList.push(exam);
			}
		}
		if (examList.length === 0) {
			isShowDialog = false;
			errorMessages.exam = '※診察内容が選択されていません。';
		}

		this.errorMessageList = errorMessages;

		if (isShowDialog === false) {
			let errorMessageString = '';
			for (const val of Object.values(errorMessages)) {
				if (val !== '') {
					errorMessageString = errorMessageString + '<br>' + val;
				}
			}
			await this.showAlertDialog('エラー', errorMessageString);
			return;
		}

		this.reserveModel.examList = examList;

		this.sendFingerprintLog('ReserveSelectDetailFormFragmentComponent', 'selectDate');

		await this.eventSetReserveSaveData(this.reserveModel);
		await this.eventSelectDate();
	}

	/**
	 * select選択時のコールバック
	 * @param event
	 * @param name
	 */
	public async onSelectionChange(event: MatRadioChange, name: string): Promise<void> {

		switch (name) {
			case 'clinicId':
				const initialData = await this.eventChangeClinic();

				console.log(initialData);
				this.departmentOnlineList = initialData.departmentOnlineList;
				this.departmentVisitList = initialData.departmentVisitList;
				this.visitTypeList = initialData.visitTypeList;
				this.appointmentTypeList = initialData.appointmentTypeList;
				this.alertList = initialData.alertList;

				this.setDepartmentList(this.reserveModel.appointmentType);
				this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);

				// 来院・オンラインを未選択に戻す
				this.reserveModel.appointmentType = 'NONE';
				// 初診・再診を未選択に戻す
				this.reserveModel.visitType = 'NONE';
				// 診療科を未選択に戻す
				this.reserveModel.departmentId = 0;
				// 日時選択をリセット
				this.reserveModel.reservationDate = '';
				this.reserveModel.reservationFrom = '';
				this.reserveModel.reservationTo = '';
				this.reserveModel.doctorId = 0;

				// エラーメッセージの削除
				if (this.reserveModel.clinicId !== 0) {
					this.errorMessageList.clinic = '';
				}

				// 注意事項をリセット
				this.selectedAppointmentTypeCaution = [];
				this.selectedVisitTypeCaution = [];

				break;

			// 来院・オンライン選択
			// 診療科リストを入れ替える
			case 'appointmentType':
				this.setDepartmentList(this.reserveModel.appointmentType);
				this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);
				// 診療科を未選択に戻す
				this.reserveModel.departmentId = 0;
				this.selectedDepartment = null;
				// 診察内容をリセット
				this.examList = [];
				this.selectedExam = null;
				// 日時選択をリセット
				this.reserveModel.reservationDate = '';
				this.reserveModel.reservationFrom = '';
				this.reserveModel.reservationTo = '';
				this.reserveModel.doctorId = 0;

				// 注意事項を入れ替える
				this.selectedAppointmentTypeCaution = [];
				switch (this.reserveModel.appointmentType) {
					case 'VISIT':
						this.selectedAppointmentTypeCaution = this.alertList.VISIT;
						break;
					case 'ONLINE':
						this.selectedAppointmentTypeCaution = this.alertList.ONLINE;
						break;
				}

				// エラーメッセージの削除
				if (this.reserveModel.appointmentType !== 'NONE') {
					this.errorMessageList.appointmentType = '';
				}
				break;

			// 診療科選択
			// 医師一覧の更新と選択医師の変更、タイムテーブルの更新
			case 'departmentId':
				break;

			case 'visitType':
				// 注意事項の入れ替え
				this.selectedVisitTypeCaution = [];
				switch (this.reserveModel.visitType) {
					case 'FIRST':
						this.selectedVisitTypeCaution = this.alertList.FIRST;
						break;
					case 'AGAIN':
						this.selectedVisitTypeCaution = this.alertList.AGAIN;
						break;
				}
				// エラーメッセージの削除
				if (this.reserveModel.visitType !== 'NONE') {
					this.errorMessageList.visitType = '';
				}
				break;
		}

	}


	/**
	 * 診療科選択時のコールバック
	 * @param department
	 */
	public async onSelectDepartment(department: DepartmentListDTOInterface): Promise<void> {

		this.reserveModel.departmentId = department.id;
		this.selectedDepartment = department;

		// 診療科選択
		// 医師一覧の更新と選択医師の変更、タイムテーブルの更新
		this.log(this.reserveModel);
		// 診察内容のリセット
		this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);
		this.selectedExam = null;

		// 日時選択をリセット
		this.reserveModel.reservationDate = '';
		this.reserveModel.reservationFrom = '';
		this.reserveModel.reservationTo = '';
		this.reserveModel.doctorId = 0;
	}

	/**
	 * 診察内容のリセット
	 * @param selectedExam
	 */
	public async selectedDepartmentExam(selectedExam: DepartmentExamDTOInterface): Promise<void> {
		this.log('selectedDepartmentExam');
		this.log(selectedExam);
		this.selectedExam = selectedExam;
		this.selectedExamId = selectedExam.id;

		for (const exam of this.examList) {
			if (exam.id === this.selectedExam.id) {
				exam.isChecked = true;
			} else {
				exam.isChecked = false;
			}
		}
	}

	/**
	 * 診療科選択
	 * @param department
	 */
	public async onClickDepartmentItem(department: DepartmentListDTOInterface): Promise<void> {
		await this.showDialogWindow(
			ReserveDepartmentAlertPopoverComponent,
			{
				department,
				onSelect: this.onSelectDepartment.bind(this),
				close: this.dismissDialogWindow.bind(this),
			}
		);
	}

	/**
	 * 診療科の選択ダイアログの表示
	 * @param department
	 */
	public async openDepartmentSelect(department?: DepartmentListDTOInterface): Promise<void> {
		if (this.reserveModel.appointmentType === 'NONE') {
			await this.showAlertDialog('エラー', '来院・オンライン診療を選択してください');
			return;
		}

		await this.showDialogWindow(
			ReserveDepartmentSelectPopoverComponent,
			{
				department,
				departmentList: this.departmentList,
				onSelect: this.onSelectDepartment.bind(this),
				close: this.dismissDialogWindow.bind(this),
			}
		);
	}

	/**
	 * 診察内容選択
	 * @param exam
	 */
	public async onClickDepartmentExamItem(exam: any): Promise<void> {
		await this.showDialogWindow(
			ReserveDepartmentExamAlertPopoverComponent,
			{
				exam,
				onSelect: this.selectedDepartmentExam.bind(this),
				close: this.dismissDialogWindow.bind(this),
			}
		);
	}

	public async openDepartmentExamSelect(exam?: DepartmentExamDTOInterface): Promise<void> {
		if (this.reserveModel.departmentId === 0) {
			await this.showAlertDialog('エラー', '診療科を選択してください');
			return;
		}

		await this.showDialogWindow(
			ReserveDepartmentExamSelectPopoverComponent,
			{
				exam,
				departmentExamList: this.examList,
				onSelect: this.selectedDepartmentExam.bind(this),
				close: this.dismissDialogWindow.bind(this),
			}
		);
	}

	/**
	 * エラー表示
	 * @param title
	 * @param text
	 */
	public showAlertDialog(title: string, text: string) {
		this.showDialogWindow(ReservePopoverAlertComponent, {
			title,
			text,
			close: this.dismissDialogWindow.bind(this),
		});
	}

}

